var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Breakpoints, CTA, ToastNotification, styled, } from '@volkswagen-onehub/components-core';
import React from 'react';
const StyledNotificationWrapper = styled.div `
  position: fixed;
  display: flex;
  overflow: hidden;
  flex-direction: column-reverse;
  top: 120px;
  right: ${(props) => props.theme.size.dynamic0100};
  left: ${(props) => props.theme.size.dynamic0100};

  @media (min-width: ${Breakpoints.b560}px) {
    width: fit-content;
    left: unset;
  }
  & > div {
    position: static;
    margin: 0 0 ${(props) => props.theme.size.static150};
    animation: fadeIn 0.3s;
    @media (min-width: ${Breakpoints.b560}px) {
      min-width: 285px;
    }
    :has(.closing) {
      animation: fadeOut 0.3s 1;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(50%) scale(0.9);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(0.9);
    }
  }
`;
const mapAppearence = (appearence = 'Neutral') => {
    switch (appearence) {
        case 'Alert':
            return 'Alert';
        case 'Informative':
            return 'Informative';
        case 'Success':
            return 'Success';
        case 'Neutral':
            return 'Neutral';
        default: {
            const exhaustiveCheck = appearence;
            throw new Error(exhaustiveCheck);
        }
    }
};
export const NotificationManagerFeatureApp = ({ service, numberOfNotifications = 1 }) => {
    var _a;
    const [notifications, setNotifications] = React.useState((_a = service === null || service === void 0 ? void 0 : service.getNotifications()) !== null && _a !== void 0 ? _a : []);
    React.useEffect(() => service
        ? service.subscribe((notificationEvent) => {
            if (notificationEvent.type === 'shown') {
                return;
            }
            setNotifications(service.getNotifications());
        })
        : () => undefined, [service]);
    return (React.createElement(StyledNotificationWrapper, null, notifications.map((item, index) => {
        const _a = item.props, { action, appearance, onShown } = _a, rest = __rest(_a, ["action", "appearance", "onShown"]);
        const mappedAppearence = mapAppearence(appearance);
        const actionCTA = action ? (React.createElement(CTA, Object.assign({}, action.props),
            " ",
            action.text)) : undefined;
        return (React.createElement(ToastNotification, Object.assign({ key: item.id, appearance: mappedAppearence, action: actionCTA }, rest, { show: item.shown(index < numberOfNotifications), onClose: (e) => {
                var _a, _b;
                e.currentTarget.classList.add('closing');
                item.close();
                (_b = (_a = item.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            } })));
    })));
};
//# sourceMappingURL=app.js.map